var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-footer"},[_c('el-pagination',{attrs:{"current-page":_vm.page,"page-sizes":_vm.pagesizes,"page-size":_vm.limit,"layout":_vm.layout,"total":_vm.total,"small":_vm.small,"background":""},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }